import { useState } from "react";
import { AdminModules } from "../features";
import { gql, useMutation } from "@apollo/client";
import { useApolloQuery } from "../../../../hooks";
import { useAuthSession } from "../../../../components/AuthSessionProvider";
import { useNotify } from "../../../../components/@common/NotificationsProvider";
import { useNavigate } from "react-router-dom";
import {
  ConfirmationDeleteModal,
  useLanguageTranslator,
} from "../../../../components";
import dayjs from "dayjs";

const GET_THEMES_WITH_PAGINATION = gql`
  query GetThemesWithPagination($page: Int!) {
    themesWithPagination(page: $page) {
      collection {
        id
        title
        createdAt
        updatedAt
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`;

const DELETE_THEME = gql`
  mutation DeleteTheme($id: ID!) {
    themeDelete(input: { id: $id }) {
      clientMutationId
      theme {
        id
        title
        createdAt
        updatedAt
      }
    }
  }
`;

function Themes() {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isOpenDelete, setIsOpenDelete] = useState({ status: false, data: {} });

  const { user } = useAuthSession() as any;
  const notify = useNotify();
  const navigate = useNavigate();

  const { translator } = useLanguageTranslator();

  const { data, loading, refetch } = useApolloQuery({
    queryDocument: GET_THEMES_WITH_PAGINATION,
    isPrivateCall: true,
    variables: {
      page: page,
    },
  });

  const [deleteTheme, { loading: deleteLoading, error }] = useMutation(
    DELETE_THEME,
    {
      context: {
        headers: {
          "access-token": user?.accessToken,
          client: user?.client,
          uid: user?.email,
        },
      },
    }
  );

  const modifiedGetThemes = data?.themesWithPagination?.collection?.map(
    (item: any) => {
      return {
        sr: item?.id,
        id: item?.id,
        name: item?.title,
        createdAt: dayjs(item?.createdAt?.split("T")?.[0] || "").format(
          "DD.MM.YYYY"
        ),
        updatedAt: dayjs(item?.updatedAt?.split("T")?.[0] || "").format(
          "DD.MM.YYYY"
        ),
      };
    }
  );

  async function onClickHandler(type: string, clickedId: any) {
    if (type === "edit") {
      navigate(`/admin/themes/update?id=${clickedId}`);
      return;
    }

    if (type === "delete") {
      setIsOpenDelete({ status: true, data: { id: clickedId } });
    }
  }

  async function onClickDeleteHandler(item: any) {
    const response = await deleteTheme({
      variables: { id: Number(item?.id) },
    });
    if (response?.data) {
      notify.success(`Theme Delete successfuly!`);
      setIsOpenDelete({ status: false, data: {} });
      setTimeout(async () => {
        await refetch();
      }, 1000);
    }
  }

  function handleDeleteClose() {
    setIsOpenDelete({ status: false, data: {} });
  }

  return (
    <>
      <ConfirmationDeleteModal
        isOpen={isOpenDelete?.status}
        item={isOpenDelete?.data}
        onClickHandler={onClickDeleteHandler}
        handleClose={handleDeleteClose}
      />
      <AdminModules
        title={`${translator("Theme")}s`}
        path="/admin/themes/add-new"
        data={modifiedGetThemes}
        moduleKey="themes-module"
        page={page}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        setPage={setPage}
        onClickHandler={onClickHandler}
        metadata={data?.themesWithPagination?.metadata || {}}
      />
    </>
  );
}

export { Themes };
